import React from 'react';
import PropTypes from 'prop-types';
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import { FormattedMessage, injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import messages from './budgetMessages';

const GlobalActionsButton = props => {
  const {
    intl,
    disabled,
    onUpdateBudgetAmount,
    onUpdateBudgetHours,
    onCopyBudget,
    inProgress,
    canUpdateAmounts,
    canUpdateHours,
  } = props;

  return (
    <span className="tool-tip" data-toggle="tooltip" data-placement="top">
      <DropdownButton
        bsSize="xsmall"
        bsStyle="default"
        className="btn-inverse"
        id="global-actions-button"
        disabled={disabled || inProgress}
        pullRight
        title={
          <span>
            {inProgress && <i className="fa fa-spinner fa-spin margin5R" />}
            <FormattedMessage {...messages.GlobalActions} />
          </span>
        }
      >
        {canUpdateAmounts ? (
          <MenuItem onSelect={onUpdateBudgetAmount} id="global-actions-button-UpdateAmount">
            {intl.formatMessage(messages.UpdateBudgetAmount)}
          </MenuItem>
        ) : null}
        {canUpdateHours ? (
          <MenuItem onSelect={onUpdateBudgetHours} id="global-actions-button-UpdateAmount">
            {intl.formatMessage(messages.UpdateBudgetHours)}
          </MenuItem>
        ) : null}
        <MenuItem onSelect={onCopyBudget} id="global-actions-button-copy">
          {intl.formatMessage(messages.CopyBudget)}
        </MenuItem>
      </DropdownButton>
    </span>
  );
};

GlobalActionsButton.propTypes = {
  intl: intlShape.isRequired,
  onUpdateBudgetAmount: PropTypes.func.isRequired,
  onUpdateBudgetHours: PropTypes.func.isRequired,
  onCopyBudget: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  inProgress: PropTypes.bool,
  canUpdateAmounts: PropTypes.bool,
  canUpdateHours: PropTypes.bool,
};
GlobalActionsButton.defaultProps = {
  disabled: false,
  inProgress: false,
  canUpdateAmounts: false,
  canUpdateHours: false,
};
export default injectIntl(GlobalActionsButton);
